import { render, staticRenderFns } from "./usercollect.vue?vue&type=template&id=022c22b4"
import script from "./usercollect.vue?vue&type=script&lang=js"
export * from "./usercollect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports